export default {
  FETCH_WAITINGLISTS_REQUEST: 'FETCH_WAITINGLISTS_REQUEST',
  FETCH_WAITINGLISTS_ERROR: 'FETCH_WAITINGLISTS_ERROR',
  FETCH_WAITINGLISTS_SUCCESS: 'FETCH_WAITINGLISTS_SUCCESS',
  SET_WAITINGLISTS_CACHE: 'SET_WAITINGLISTS_CACHE',
}
